<template>
  <v-container fluid>
    <v-row>
      <v-col md="6" cols="12" class="pr-1">
        <v-row>
          <v-col cols="12" class="pb-2">
            <base-material-card color="primary" icon="mdi-key" title="Vizualizar SQL do Relatório" inline class="ml-0 px-5 py-4">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-text-field :value="nome" :loading="loading" label="Nome" class="name-sql-read-only pt-5" readonly />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-card class="mt-0">
                    <v-toolbar flat>
                      <v-tabs grow>
                        <v-tab>Consulta SQL</v-tab>
                      </v-tabs>
                    </v-toolbar>
                    <v-textarea
                      v-model="consultaSQL"
                      class="mx-4 ta-padding-c3"
                      rows="16"
                      no-resize
                      background-color="#EEEEEE"
                      readonly
                      :loading="loading"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </base-material-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" cols="12" class="pl-1">
        <v-row>
          <v-col cols="12" class="pb-2">
            <base-material-card
              color="primary"
              icon="mdi-table-eye"
              title="Estrutura das Bases de Dados"
              inline
              class="ml-0 px-5 py-4"
            >
              <estrutura-bases-dados-liberadas class="mt-8" />
            </base-material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService';

  export default {
    components: {
      EstruturaBasesDadosLiberadas: () => import('@/components/general/GeneralEstruturaBasesDadosLiberadas')
    },

    data: () => ({
      nome: '',
      consultaSQL: '',
      loading: false
    }),

    created() {
      this.getRelatorio();
    },

    methods: {
      getRelatorio() {
        this.loading = true;

        RelatoriosService.getRelatorioConsulta(this.$route.params.id)
          .then((response) => {
            const { nome, codigo_sql } = response.data.consulta;
            this.nome = nome;
            this.consultaSQL = codigo_sql;
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao recuperar relatório.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>

<style>
  .ta-padding-c3 .v-text-field__slot {
    padding: 8px;
  }
  .ta-padding-c3 textarea {
    font-size: 11px !important;
    font-weight: bold !important;
  }
  .name-sql-read-only input {
    font-size: 13px !important;
    opacity: 0.7;
  }
</style>